module.exports = __webpack_public_path__ + "static/media/20-web-or-mls-DSC06617.4bbb529e.jpg";